import React, { useState, useEffect } from 'react';
import Icon from '../../Components/Icons/Icon';
// import { useAssistantContext } from '../../Components/Assistant';
import { Link } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import GlobalSearch from '../../Components/GlobalSearch';
import { levels } from '../../Data/Admin';
import newMenu from '../newMenu';
import { classNames } from '../../Services/helpers';
import { useDialogues } from '../../Components/Dialogues';
import useHomeBadge from '../../Data/useHomeBadge';

const NavRedesign = () => {
    const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
    const {confirm, featureUnavailable} = useDialogues();
    const { logout, isAdmin, isAdminSwitched, adminSwitchBack, setShowRedesign, showDarkMode, setShowDarkMode, hasFeature } = useSession();
    const homeBadge = useHomeBadge();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setGlobalSearchOpen(true);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <div className="grow-0 pt-2 pr-2 max-h-screen min-h-screen print:hidden dark:text-slate-100 dark:fill-slate-100">
            <nav className="mt-2 fixed mx-auto h-full overflow-y-auto">

            <div className="mb-4 flex items-center gap-3 px-3 py-2 cursor-pointer bg-white dark:bg-black border dark:border-none rounded-full w-full text-muted"
                onClick={() => setGlobalSearchOpen(true)}
            >
                <Icon icon="MagnifyingGlass" size="1x" />
                <span className="font-medium">Search</span>
                <KeyboardShortcut shortcut="Ctrl+K" />
            </div>

            {newMenu.map((section) => (
                    <div key={section.title} className="mb-6">
                        <div className="flex items-center mb-3">
                            <Icon
                                icon={section.icon}
                                size="1x"
                                className="fill-gray-800 dark:fill-gray-200 mr-3"
                                badge={section.notifications ? (homeBadge ? true : null) : null}
                            />
                            <h2 className="text-gray-800 dark:text-gray-200 font-bold text-base">{section.title}</h2>
                        </div>

                        <div className="ml-8 space-y-2">
                            {section.items.map((item) => {
                                const isLocked = item.feature && !hasFeature(item.feature);

                                if (isLocked) {
                                    return (
                                        <div
                                            key={item.label}
                                            onClick={() => featureUnavailable(item.feature)}
                                            className={classNames(
                                                "py-1 transition-colors text-left cursor-pointer flex items-center justify-between",
                                                "text-gray-400 dark:text-gray-500"
                                            )}
                                        >
                                            <span>{item.label}</span>
                                            <Icon icon="Lock" size="0.75x" className="fill-gray-400 dark:fill-gray-500" />
                                        </div>
                                    );
                                }

                                return (
                                    <Link
                                        key={item.label}
                                        to={item.disabled ? null : item.to}
                                        onClick={item.disabled ? null : null}
                                        className={classNames(
                                            "block py-1 transition-colors text-left",
                                            item.disabled ? "text-gray-400 dark:text-gray-500 cursor-not-allowed" : "text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                                        )}
                                    >
                                        {item.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                ))}

                {/* Admin Section */}
                {isAdmin(levels.READ_ONLY) && (
                    <div className="mb-6">
                        <div className="flex items-center mb-3">
                            <Icon
                                icon="Wrench"
                                size="1x"
                                className="fill-gray-800 dark:fill-gray-200 mr-3"
                            />
                            <h2 className="text-gray-800 dark:text-gray-200 font-bold text-base">Admin</h2>
                        </div>

                        <div className="ml-8 space-y-2">
                            <Link
                                to="/admin"
                                className="block py-1 transition-colors text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                            >
                                Admin Panel
                            </Link>
                            {isAdminSwitched && (
                                <div
                                    className="block py-1 transition-colors text-left text-red-600 cursor-pointer hover:text-red-700"
                                    onClick={() => adminSwitchBack()}
                                >
                                    Switch back
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Separator */}
                <div className="border-t border-gray-200 dark:border-gray-700 my-4"></div>

                {/* Settings and Log Out */}
                <div className="space-y-2">
                    <div className="flex items-center py-1">
                        <Link to="/more">
                            <Icon icon="Gear" size="1x" className="fill-gray-800 dark:fill-gray-200 mr-3" />
                            <span className="text-gray-800 dark:text-gray-200">Settings</span>
                        </Link>
                    </div>
                    <div className="flex items-center py-1 cursor-pointer"
                        onClick={() => confirm(
                            {theme: 'danger', title: 'Logout', message: 'Are you sure you want to logout?', confirmLabel: 'Logout'},
                            async () => {
                                await logout();
                                window.location.reload();
                            }
                        )}
                    >
                        <Icon icon="ArrowLeftToBracket" size="1x" className="fill-gray-800 dark:fill-gray-200 mr-3" />
                        <span className="text-gray-800 dark:text-gray-200">Log Out</span>
                    </div>
                </div>

                {/* Separator */}
                <div className="border-t border-gray-200 dark:border-gray-700 my-4"></div>

                <div className="flex justify-start gap-4">
                    <button
                        className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                        onClick={() => confirm(
                            {
                                theme: 'warning',
                                title: 'Turn off redesign?',
                                message: 'Are you sure you want to turn off the redesign?',
                                confirmLabel: 'Turn off',
                                cancelLabel: 'Cancel',
                            },
                            () => setShowRedesign(false)
                        )}
                    >
                        <Icon icon="Brush" size="1x" className="fill-gray-800 dark:fill-gray-200" />
                    </button>
                    <button
                        className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                        onClick={() => setShowDarkMode(!showDarkMode)}
                    >
                        <Icon icon={showDarkMode ? 'SunBright' : 'Moon'} size="1x" className="fill-gray-800 dark:fill-gray-200" />
                    </button>
                </div>

                {/*
                <Link to="/" className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full">
                    <Icon icon="HouseChimney" size="2x" badge={notificationBadge} />
                    <span className="font-medium">Home</span>
                </Link>


                <div className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full"
                    onClick={() => setSwitcherOpen(!switcherOpen)}
                >
                    <Icon icon="GridRound2" size="2x" />
                    <span className="font-medium">Menu</span>
                    <KeyboardShortcut shortcut="Ctrl+J" />
                </div>

                <div className="mt-auto">
                    <Assistant />
                </div>
                */}
            </nav>

            <div className="w-[200px]">&nbsp;</div>

            <GlobalSearch isOpen={globalSearchOpen} setIsOpen={() => setGlobalSearchOpen(false)} />
        </div>
    );
};

/*
const Assistant = () => {
    const { assistantOpen, setAssistantOpen, unseen } = useAssistantContext();
    const {showDarkMode} = useSession();

    return (
        <div
            className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full"
            onClick={() => setAssistantOpen(!assistantOpen)}
        >
            <Icon
                icon={
                    assistantOpen || unseen ? (showDarkMode ? "SidSolidDark" : "SidSolid") : (showDarkMode ? "SidLightDark" : "SidLight")
                }
                theme="soapy"
                size="2x"
                badge={unseen}
            />
            <span className="font-medium">Sid</span>
        </div>
    );
};
*/

const KeyboardShortcut = ({ shortcut }) => {
    const isMac = () => {
        if (navigator.userAgentData) {
            return navigator.userAgentData.platform === 'macOS';
        }
        return /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
    };

    return (
        <span className="text-muted">
            ({isMac() ? shortcut.replace('Ctrl', '⌘') : shortcut})
        </span>
    );
};

export default NavRedesign;
